// Generated by scripts/update-seeq-icons.js from src/svg/seeq/long-dash-dot.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcLongDashDot = {
  prefix: 'fak',
  iconName: 'long-dash-dot' as IconName,
  icon: [
    1024,
    1024,
    [],
    'f909',
    'M363.5 512h583.7v46.1h-583.7v-46.1zM71.7 512h81.9v46.1h-81.9v-46.1zM71.7 465.9h81.9v46.1h-81.9v-46.1zM363.5 465.9h583.7v46.1h-583.7v-46.1z',
  ],
} satisfies IconDefinition;
